import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { DraftContext } from './ContextProvider'
import { SectionTitle, Card } from '../tools'
import { usePestelStore } from '../store'

function SuggestCard({ setting }) {
  const { boardStyle } = setting

  const {
    politic,
    economic,
    social,
    technology,
    environment,
    law,
    updatePestelInfo,
    removePestelInfo,
    addPestelInfo,
    updateFullPestelInfo,
  } = usePestelStore((store) => ({
    politic: store.politic,
    economic: store.economic,
    social: store.social,
    technology: store.technology,
    environment: store.environment,
    law: store.law,
    updatePestelInfo: store.updatePestelInfo,
    removePestelInfo: store.removePestelInfo,
    addPestelInfo: store.addPestelInfo,
    updateFullPestelInfo: store.updateFullPestelInfo,
  }))
  console.log(politic)

  const { draftId } = useContext(DraftContext)
  // const { cardList, setCardList } = useContext(DraftContext)

  // undo and redo
  // const {
  //   cursor,
  //   setCursor,
  //   history,
  //   setHistory,
  //   recoverTarget,
  //   setRecoverTarget,
  // } = useContext(DraftContext)

  // useEffect(() => {
  //   setHistory([module])
  //   setCursor(-1)
  //   setRecoverTarget(-1)
  // }, [])

  // useEffect(() => {
  //   if (recoverTarget !== -1) {
  //     setCardList(history[recoverTarget])
  //   }
  // }, [recoverTarget])

  // useEffect(() => {
  //   setCardList(module)
  // }, [module])

  // useEffect(() => {
  //   if (recoverTarget >= 0) {
  //     setCursor(recoverTarget)
  //     setRecoverTarget(-1)
  //   } else {
  //     setHistory((prevState) => [...prevState.slice(0, cursor + 1), module])
  //     setCursor((prevState) => prevState + 1)
  //   }
  // }, [cardList])

  const getFieldByLabel = (label) => {
    switch (label) {
      case 0:
        return 'politic'
      case 1:
        return 'economic'
      case 2:
        return 'social'
      case 3:
        return 'technology'
      case 4:
        return 'environment'
      case 5:
        return 'law'
      default:
        throw new Error('Invalid label')
    }
  }
  const getPartialGenerate = async (label, value) => {
    const field = getFieldByLabel(label)
    const response = await fetch(
      `${window.location.protocol}/api/draft/${draftId}/data/pestel/${field}_partial_generation/partial`,
      {
        method: 'post',
        body: JSON.stringify({
          q: value,
        }),
        headers: {
          'content-type': 'application/json',
        },
      }
    )
    // if (!response.ok) {
    //   throw new Error(`Network response was not ok for ${url}`)
    // }
    // const contentType = response.headers.get('content-type')
    // if (!contentType || !contentType.includes('application/json')) {
    //   throw new TypeError(`Received non-JSON response from ${url}`)
    // }
    const json = await response.json()
    console.log(json)
    return {
      pestel: json.pestel,
      pestel_sub: json.pestel_info[0].pestel_sub,
      content: json.pestel_info[0].content,
    }

    // if (url) {
    //   try {
    //     const response = await fetch(url)
    //     const data = await response.json()
    //     return {
    //       pestel_sub: data.pestel_sub,
    //       content: data.content,
    //     }
    //   } catch (error) {
    //     return {
    //       pestel_sub: '',
    //       content: '',
    //     }
    //   }
    // } else {
    //   return {
    //     pestel_sub: '',
    //     content: '',
    //   }
    // }
  }

  const handleCardResort = (label, cards, startIndex, endIndex) => {
    console.log(label)
    console.log(cards)
    console.log(startIndex)
    console.log(endIndex)
    const field = getFieldByLabel(label)
    const result = Array.from(cards)
    console.log(result)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)
    console.log(field)
    console.log(result)
    updateFullPestelInfo(field, result)
  }

  const labelEdit = (label, id, value) => {
    const field = getFieldByLabel(label)
    updatePestelInfo(field, id, 'pestel_sub', value)
  }

  const textEdit = (label, id, value) => {
    const field = getFieldByLabel(label)
    updatePestelInfo(field, id, 'content', value)
  }
  const removeItem = (label, j) => {
    const field = getFieldByLabel(label)
    removePestelInfo(field, j)
  }

  const addItem = async (j, label, value) => {
    const field = getFieldByLabel(label)
    await addPestelInfo(field, j, { loading: true })
    const generateData = await getPartialGenerate(label, value)
    updatePestelInfo(field, j, 'pestel_sub', generateData.pestel_sub)
    updatePestelInfo(field, j, 'content', generateData.content)
  }
  // 測試用

  const regenerateItem = async (label, j) => {
    console.log(label)
    console.log(j)
    // console.log(value)
    const field = getFieldByLabel(label)
    console.log(field)
    console.log(
      {
        politic,
        economic,
        social,
        technology,
        environment,
        law,
      }[field]
    )
    const item = {
      politic,
      economic,
      social,
      technology,
      environment,
      law,
    }[field].pestel_info[j]
    console.log(item)
    console.log(item.pestel_sub)
    updatePestelInfo(field, j, 'loading', true)
    const generateData = await getPartialGenerate(label, item.pestel_sub)
    console.log(generateData)
    updatePestelInfo(field, j, 'pestel_sub', generateData.pestel_sub)
    updatePestelInfo(field, j, 'content', generateData.content)
    updatePestelInfo(field, j, 'loading', false)
  }

  return (
    <div className="edit-block">
      <div className="row">
        {[politic, economic, social, technology, environment, law].map(
          (item, index) => (
            <div
              key={index}
              className={`stage-section ${
                boardStyle === 'list' ? 'board-row' : 'board-column'
              }`}
            >
              <div className="color-card">
                <div className="color-card-body">
                  <SectionTitle
                    setting={{
                      title: item.pestel,
                      // icon: cardList[cardKey].icon,
                      edit: false,
                    }}
                  />
                  <div className="card-wrapper">
                    <div className="module-control">
                      <Card
                        setting={{
                          labelID: index,
                          label: index,
                          // content: (item.pestel_info || []).map((pi, i) => ({
                          //   ...pi,
                          //   regenerateItem: () => {
                          //     console.log(index)
                          //     regenerateItem(index, i, pi.pestel_sub)
                          //   },
                          // })),
                          labelEdit,
                          textEdit,
                          handleCardResort,
                          addItem,
                          removeItem,
                          regenerateItem,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  )
}

SuggestCard.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default SuggestCard
